import React, { useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import StoreLocator from "../components/StoreLocator"
import { useGeolocated } from "react-geolocated";
// import GoogleMaps from "../components/GoogleMaps"

const motionSection = {
  initial: {
    opacity: 0,
    // y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    },
  },
}

const imgOverlay = {
  initial: { right: 0 },
  animate: {
    right: "100%",
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 0.6,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 0.6,
    },
  },
}
const heroImg = {
  initial: { scale: 1.1 },
  animate: {
    scale: 1,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 2,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 2,
    },
  },
}

const motionText = {
  initial: { y: 20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 1.5,
    },
  },
}

const locationFinder = ({ block, raw, index }) => {
  const data = useStaticQuery(graphql`
    query locationFinderQuery {
      allLocations: allSanityLocations {
        nodes {
          state {
            title
            slug {
              current
            }
          }
          map {
            lat
            lng
          }
          sidebarAddress
          sidebarAddressURL
          instagram
          twitter
          facebook
          title
          slug {
            current
          }
        }
      }
    }
  `)
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: false,
            },
            userDecisionTimeout: 5000,
        });
  const { flush, contained, heading, text, image } = block

  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.4,
  })

  useEffect(() => {
    if (inView) {
      controls.start("animate")
    }
  }, [controls, inView])

  const [zoom, setZoom] = React.useState(13); // initial zoom
  const [center, setCenter] = React.useState<google.maps.LatLngLiteral>({
    lat: coords ? coords?.latitude : 33.838181,
    lng: coords ? coords?.longitude : -84.377327
  });

  const [locations, setLocations] = useState([])
  const [userLocation, setUserLocation] = useState({
    lat: 0,
    lng: 0
  })

  // console.log("locations", locations)



    const locationArray = data.allLocations.nodes.map(location => 
      ({
        "lat": location.map ? location.map.lat : 0,
        "lng": location.map ? location.map.lng : 0
      }));

      // console.log("locationArray", locationArray)
  // useEffect(() => {
  //   const locationArray = data.allLocations.nodes.map(location) => (
  //     {
  //       "lat": location.map.lat,
  //       "lng": location.map.lng
  //     }
  //   )
  //   // {coords &&  
  //   //   setUserLocation({
  //   //   "lat": coords.latitude,
  //   //   "lng": coords.longitude
  //   // })}

  // }, [data])

  // console.log(locations)



  return (
    <motion.section
      className={(flush ? "" : "section ") + "module-hero page-header"}
      ref={ref}
      animate={controls}
      initial="initial"
      variants={motionSection}
    >
      <div
        className={
          contained
            ? "container max-w-screen-xl relative"
            : "section--px relative"
        }
      >
        <StoreLocator  locations={locationArray}/>
        {/* <Wrapper apiKey={process.env.GATSBY_GOOGLE_MAPS_KEY} render={render} center={center} zoom={zoom} style={{ height: "200px", width: "100%" }}/> */}
      </div>
    </motion.section>
  )
}

export default locationFinder
